/**
 * Add Nofollow Links to Table of Contents Element from Elementor
 * 
 */

export default () => {
    window.addEventListener('elementor/frontend/init', function() {
        elementorFrontend.hooks.addAction( 'frontend/element_ready/table-of-contents.default', function( $scope ) {
            // Erstelle einen MutationObserver da das DOM nachträglich von Elementor JS geändert wird
            const observer = new MutationObserver(function(mutationsList) {
                for(let mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        let tocElement = $scope.find('.elementor-toc__list-item-text')
                        tocElement.each(function() {
                            let href = $(this).attr('href')
                            if (href) {
                                $(this).attr('rel', 'nofollow')
                            }
                        })
                    }
                }
            });
            // Starte den Observer und überwache das DOM von $scope
            observer.observe($scope[0], { childList: true, subtree: true });
        } );
    }
)}
